import {
    Dialog,
    DialogTitle,
    makeStyles,
    IconButton,
    DialogContent,
    DialogActions,
    Button,
    Paper,
} from '@material-ui/core';
import CloseIcon from '@material-ui/icons/Close';
import Draggable from 'react-draggable';
import { Trans } from '@lingui/macro';

import ProblemsTable from '../problems/ProblemsTable';
import { timeRangeFormatter } from '../../utilities';

const useStyles = makeStyles((theme) => ({
    title: {
        margin: 0,
        padding: theme.spacing(2),
        cursor: 'move',
    },
    closeButton: {
        position: 'absolute',
        right: theme.spacing(1),
        top: theme.spacing(1),
        color: theme.palette.grey[500],
    },
}));

function PaperComponent(props) {
    return (
        <Draggable handle="#draggable-problems-dialog-title" cancel={'[class*="MuiDialogContent-root"]'}>
            <Paper {...props} />
        </Draggable>
    );
}

export default function ProblemsDialog({ open, onClose, timeRange, total, entityType, entityUuid }) {
    const classes = useStyles();
    const timeRangeStr = timeRangeFormatter(timeRange);
    return (
        <Dialog
            fullWidth
            maxWidth="lg"
            open={open}
            onClose={onClose}
            PaperComponent={PaperComponent}
            aria-labelledby="draggable-problems-dialog-title"
        >
            <DialogTitle className={classes.title} id="draggable-problems-dialog-title">
                {timeRangeStr}
                <IconButton aria-label="close" className={classes.closeButton} onClick={onClose}>
                    <CloseIcon />
                </IconButton>
            </DialogTitle>
            <DialogContent>
                <ProblemsTable total={total} timeRange={timeRange} entityType={entityType} entityUuid={entityUuid} />
            </DialogContent>
            <DialogActions>
                <Button onClick={onClose} color="primary" autoFocus>
                    <Trans>Close</Trans>
                </Button>
            </DialogActions>
        </Dialog>
    );
}
